import { SVGProps } from "react";

export default function ButtonIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 13, width = 12, fill = "black", ...rest } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M9.40312 3.67188H2.5875C1.34062 3.67188 0.328125 4.68672 0.328125 5.93125V7.0375C0.328125 8.28438 1.34297 9.29688 2.5875 9.29688H9.40078C10.6477 9.29688 11.6602 8.28203 11.6602 7.0375V5.93125C11.6625 4.68672 10.6477 3.67188 9.40312 3.67188ZM9.40312 8.09922H2.5875C1.39219 8.09922 0.421875 7.12656 0.421875 5.93359C0.421875 4.73828 1.39453 3.76797 2.5875 3.76797H9.40078C10.5961 3.76797 11.5664 4.74062 11.5664 5.93359C11.5687 7.12656 10.5961 8.09922 9.40312 8.09922Z"
        fill={fill}
      />
    </svg>
  );
}
